import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faImage,
    faVideo,
    faQuestion,
    faListOl,
    faLaugh,
    faFont,
    faQrcode,
    faVrCardboard,
    faPhotoVideo,
    faWaveSquare,
 } from "@fortawesome/free-solid-svg-icons";
 import { IconWrapper } from "./ChallengeIcon.style";
 import { getTaskTypeName } from "./Organize.utilities";

const taskIcons = [
    { value: 1, icon: <FontAwesomeIcon icon={faImage} /> },
    { value: 2, icon: <FontAwesomeIcon icon={faVideo} /> },
    { value: 5, icon: <FontAwesomeIcon icon={faQuestion} /> },
    { value: 6, icon: <FontAwesomeIcon icon={faListOl} /> },
    { value: 3, icon: <FontAwesomeIcon icon={faLaugh} /> },
    { value: 0, icon: <FontAwesomeIcon icon={faFont} /> },
    { value: 4, icon: <FontAwesomeIcon icon={faQrcode} /> },
    { value: 7, icon: <FontAwesomeIcon icon={faVrCardboard} /> },
    { value: 8, icon: <FontAwesomeIcon icon={faVrCardboard} /> },
    { value: 9, icon: <FontAwesomeIcon icon={faPhotoVideo} /> },
    { value: 10, icon: <FontAwesomeIcon icon={faPhotoVideo} /> },
    { value: 11, icon: <FontAwesomeIcon icon={faWaveSquare} /> },
]

const ChallengeIcon = ({ id, prompt, task_subtype }) => {
    const icon = taskIcons.find(({ value }) => String(id) === String(value))
    const label = getTaskTypeName(id, { prompt, task_subtype })
    return icon && label
        ? (
            <IconWrapper className="text-info">
                {icon.icon}
                <span>{label}</span>
            </IconWrapper>
        )
        : null
}

export default ChallengeIcon
